import { render, staticRenderFns } from "./ClosureInfo.vue?vue&type=template&id=b066670c&scoped=true"
import script from "./ClosureInfo.vue?vue&type=script&lang=js"
export * from "./ClosureInfo.vue?vue&type=script&lang=js"
import style0 from "./ClosureInfo.vue?vue&type=style&index=0&id=b066670c&prod&scoped=true&lang=css"
import style1 from "./ClosureInfo.vue?vue&type=style&index=1&id=b066670c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b066670c",
  null
  
)

export default component.exports